// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as RadarRouteImport } from './routes/radar'
import { Route as ResearchRouteImport } from './routes/research'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LocalePublicRouteRouteImport } from './routes/$locale/_public/route'
import { Route as LocaleRadarRouteImport } from './routes/$locale/radar'
import { Route as LocaleResearchRouteImport } from './routes/$locale/research'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicMatchesRouteImport } from './routes/_public/matches'
import { Route as PublicTeamsPlayersRouteImport } from './routes/_public/teams-players'
import { Route as AdminDataQualityRouteImport } from './routes/admin/data-quality'
import { Route as AdminMappingsRouteImport } from './routes/admin/mappings'
import { Route as AdminMonitoringRouteImport } from './routes/admin/monitoring'
import { Route as AuthPathnameRouteImport } from './routes/auth.$pathname'
import { Route as MatchesMatchIdRouteImport } from './routes/matches/$matchId'
import { Route as RadarIndexRouteImport } from './routes/radar/index'
import { Route as RadarWorldcupRouteImport } from './routes/radar/worldcup'
import { Route as ResearchIndexRouteImport } from './routes/research/index'
import { Route as ResearchEvidenceRouteImport } from './routes/research/evidence'
import { Route as ResearchHeadToHeadRouteImport } from './routes/research/head-to-head'
import { Route as ResearchOpportunitiesRouteImport } from './routes/research/opportunities'
import { Route as ResearchWorldcupRouteImport } from './routes/research/worldcup'
import { Route as SettingsPathnameRouteImport } from './routes/settings.$pathname'
import { Route as LocalePublicIndexRouteImport } from './routes/$locale/_public/index'
import { Route as LocalePublicMatchesRouteImport } from './routes/$locale/_public/matches'
import { Route as LocalePublicTeamsPlayersRouteImport } from './routes/$locale/_public/teams-players'
import { Route as LocaleAuthPathnameRouteImport } from './routes/$locale/auth.$pathname'
import { Route as LocaleMatchesMatchIdRouteImport } from './routes/$locale/matches/$matchId'
import { Route as LocaleRadarIndexRouteImport } from './routes/$locale/radar/index'
import { Route as LocaleRadarWorldcupRouteImport } from './routes/$locale/radar/worldcup'
import { Route as LocaleResearchIndexRouteImport } from './routes/$locale/research/index'
import { Route as LocaleResearchEvidenceRouteImport } from './routes/$locale/research/evidence'
import { Route as LocaleResearchHeadToHeadRouteImport } from './routes/$locale/research/head-to-head'
import { Route as LocaleResearchWorldcupRouteImport } from './routes/$locale/research/worldcup'
import { Route as PublicLegalDocumentRouteImport } from './routes/_public/legal.$document'
import { Route as PublicPlayersPlayerIdRouteImport } from './routes/_public/players/$playerId'
import { Route as PublicTeamsTeamIdRouteImport } from './routes/_public/teams/$teamId'
import { Route as PublicTeamsCompareRouteImport } from './routes/_public/teams/compare'
import { Route as RadarEventsEventIdRouteImport } from './routes/radar/events/$eventId'
import { Route as RadarOpportunitiesOpportunityIdRouteImport } from './routes/radar/opportunities/$opportunityId'
import { Route as ResearchMatchesMatchIdRouteImport } from './routes/research/matches/$matchId'
import { Route as ResearchPlayersPlayerIdRouteImport } from './routes/research/players/$playerId'
import { Route as ResearchTeamsTeamRouteImport } from './routes/research/teams/$team'
import { Route as LocalePublicLegalDocumentRouteImport } from './routes/$locale/_public/legal.$document'
import { Route as LocalePublicPlayersPlayerIdRouteImport } from './routes/$locale/_public/players/$playerId'
import { Route as LocalePublicTeamsTeamIdRouteImport } from './routes/$locale/_public/teams/$teamId'
import { Route as LocalePublicTeamsCompareRouteImport } from './routes/$locale/_public/teams/compare'
import { Route as LocaleRadarEventsEventIdRouteImport } from './routes/$locale/radar/events/$eventId'
import { Route as LocaleRadarOpportunitiesOpportunityIdRouteImport } from './routes/$locale/radar/opportunities/$opportunityId'
import { Route as LocaleResearchMatchesMatchIdRouteImport } from './routes/$locale/research/matches/$matchId'
import { Route as LocaleResearchPlayersPlayerIdRouteImport } from './routes/$locale/research/players/$playerId'
import { Route as PublicHistoryMatchesHistoricalMatchIdRouteImport } from './routes/_public/history/matches/$historicalMatchId'
import { Route as PublicTeamsTeamIdHistoryRouteImport } from './routes/_public/teams/$teamId_.history'
import { Route as RadarEventsEventIdWhaleOrdersRouteImport } from './routes/radar/events/$eventId/whale-orders'
import { Route as LocalePublicHistoryMatchesHistoricalMatchIdRouteImport } from './routes/$locale/_public/history/matches/$historicalMatchId'
import { Route as LocalePublicTeamsTeamIdHistoryRouteImport } from './routes/$locale/_public/teams/$teamId_.history'

const LocaleRouteRoute = LocaleRouteRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const PublicRouteRoute = PublicRouteRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ForbiddenRoute = ForbiddenRouteImport.update({
            id: '/forbidden',path: '/forbidden',getParentRoute: () => rootRouteImport
          })
const RadarRoute = RadarRouteImport.update({
            id: '/radar',path: '/radar',getParentRoute: () => rootRouteImport
          })
const ResearchRoute = ResearchRouteImport.update({
            id: '/research',path: '/research',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const LocalePublicRouteRoute = LocalePublicRouteRouteImport.update({
            id: '/_public',getParentRoute: () => LocaleRouteRoute
          })
const LocaleRadarRoute = LocaleRadarRouteImport.update({
            id: '/radar',path: '/radar',getParentRoute: () => LocaleRouteRoute
          })
const LocaleResearchRoute = LocaleResearchRouteImport.update({
            id: '/research',path: '/research',getParentRoute: () => LocaleRouteRoute
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRouteRoute
          })
const PublicMatchesRoute = PublicMatchesRouteImport.update({
            id: '/matches',path: '/matches',getParentRoute: () => PublicRouteRoute
          })
const PublicTeamsPlayersRoute = PublicTeamsPlayersRouteImport.update({
            id: '/teams-players',path: '/teams-players',getParentRoute: () => PublicRouteRoute
          })
const AdminDataQualityRoute = AdminDataQualityRouteImport.update({
            id: '/data-quality',path: '/data-quality',getParentRoute: () => AdminRoute
          })
const AdminMappingsRoute = AdminMappingsRouteImport.update({
            id: '/mappings',path: '/mappings',getParentRoute: () => AdminRoute
          })
const AdminMonitoringRoute = AdminMonitoringRouteImport.update({
            id: '/monitoring',path: '/monitoring',getParentRoute: () => AdminRoute
          })
const AuthPathnameRoute = AuthPathnameRouteImport.update({
            id: '/auth/$pathname',path: '/auth/$pathname',getParentRoute: () => rootRouteImport
          })
const MatchesMatchIdRoute = MatchesMatchIdRouteImport.update({
            id: '/matches/$matchId',path: '/matches/$matchId',getParentRoute: () => rootRouteImport
          })
const RadarIndexRoute = RadarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RadarRoute
          })
const RadarWorldcupRoute = RadarWorldcupRouteImport.update({
            id: '/worldcup',path: '/worldcup',getParentRoute: () => RadarRoute
          })
const ResearchIndexRoute = ResearchIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ResearchRoute
          })
const ResearchEvidenceRoute = ResearchEvidenceRouteImport.update({
            id: '/evidence',path: '/evidence',getParentRoute: () => ResearchRoute
          })
const ResearchHeadToHeadRoute = ResearchHeadToHeadRouteImport.update({
            id: '/head-to-head',path: '/head-to-head',getParentRoute: () => ResearchRoute
          })
const ResearchOpportunitiesRoute = ResearchOpportunitiesRouteImport.update({
            id: '/opportunities',path: '/opportunities',getParentRoute: () => ResearchRoute
          })
const ResearchWorldcupRoute = ResearchWorldcupRouteImport.update({
            id: '/worldcup',path: '/worldcup',getParentRoute: () => ResearchRoute
          })
const SettingsPathnameRoute = SettingsPathnameRouteImport.update({
            id: '/$pathname',path: '/$pathname',getParentRoute: () => SettingsRoute
          })
const LocalePublicIndexRoute = LocalePublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocalePublicRouteRoute
          })
const LocalePublicMatchesRoute = LocalePublicMatchesRouteImport.update({
            id: '/matches',path: '/matches',getParentRoute: () => LocalePublicRouteRoute
          })
const LocalePublicTeamsPlayersRoute = LocalePublicTeamsPlayersRouteImport.update({
            id: '/teams-players',path: '/teams-players',getParentRoute: () => LocalePublicRouteRoute
          })
const LocaleAuthPathnameRoute = LocaleAuthPathnameRouteImport.update({
            id: '/auth/$pathname',path: '/auth/$pathname',getParentRoute: () => LocaleRouteRoute
          })
const LocaleMatchesMatchIdRoute = LocaleMatchesMatchIdRouteImport.update({
            id: '/matches/$matchId',path: '/matches/$matchId',getParentRoute: () => LocaleRouteRoute
          })
const LocaleRadarIndexRoute = LocaleRadarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRadarRoute
          })
const LocaleRadarWorldcupRoute = LocaleRadarWorldcupRouteImport.update({
            id: '/worldcup',path: '/worldcup',getParentRoute: () => LocaleRadarRoute
          })
const LocaleResearchIndexRoute = LocaleResearchIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleResearchRoute
          })
const LocaleResearchEvidenceRoute = LocaleResearchEvidenceRouteImport.update({
            id: '/evidence',path: '/evidence',getParentRoute: () => LocaleResearchRoute
          })
const LocaleResearchHeadToHeadRoute = LocaleResearchHeadToHeadRouteImport.update({
            id: '/head-to-head',path: '/head-to-head',getParentRoute: () => LocaleResearchRoute
          })
const LocaleResearchWorldcupRoute = LocaleResearchWorldcupRouteImport.update({
            id: '/worldcup',path: '/worldcup',getParentRoute: () => LocaleResearchRoute
          })
const PublicLegalDocumentRoute = PublicLegalDocumentRouteImport.update({
            id: '/legal/$document',path: '/legal/$document',getParentRoute: () => PublicRouteRoute
          })
const PublicPlayersPlayerIdRoute = PublicPlayersPlayerIdRouteImport.update({
            id: '/players/$playerId',path: '/players/$playerId',getParentRoute: () => PublicRouteRoute
          })
const PublicTeamsTeamIdRoute = PublicTeamsTeamIdRouteImport.update({
            id: '/teams/$teamId',path: '/teams/$teamId',getParentRoute: () => PublicRouteRoute
          })
const PublicTeamsCompareRoute = PublicTeamsCompareRouteImport.update({
            id: '/teams/compare',path: '/teams/compare',getParentRoute: () => PublicRouteRoute
          })
const RadarEventsEventIdRoute = RadarEventsEventIdRouteImport.update({
            id: '/events/$eventId',path: '/events/$eventId',getParentRoute: () => RadarRoute
          })
const RadarOpportunitiesOpportunityIdRoute = RadarOpportunitiesOpportunityIdRouteImport.update({
            id: '/opportunities/$opportunityId',path: '/opportunities/$opportunityId',getParentRoute: () => RadarRoute
          })
const ResearchMatchesMatchIdRoute = ResearchMatchesMatchIdRouteImport.update({
            id: '/matches/$matchId',path: '/matches/$matchId',getParentRoute: () => ResearchRoute
          })
const ResearchPlayersPlayerIdRoute = ResearchPlayersPlayerIdRouteImport.update({
            id: '/players/$playerId',path: '/players/$playerId',getParentRoute: () => ResearchRoute
          })
const ResearchTeamsTeamRoute = ResearchTeamsTeamRouteImport.update({
            id: '/teams/$team',path: '/teams/$team',getParentRoute: () => ResearchRoute
          })
const LocalePublicLegalDocumentRoute = LocalePublicLegalDocumentRouteImport.update({
            id: '/legal/$document',path: '/legal/$document',getParentRoute: () => LocalePublicRouteRoute
          })
const LocalePublicPlayersPlayerIdRoute = LocalePublicPlayersPlayerIdRouteImport.update({
            id: '/players/$playerId',path: '/players/$playerId',getParentRoute: () => LocalePublicRouteRoute
          })
const LocalePublicTeamsTeamIdRoute = LocalePublicTeamsTeamIdRouteImport.update({
            id: '/teams/$teamId',path: '/teams/$teamId',getParentRoute: () => LocalePublicRouteRoute
          })
const LocalePublicTeamsCompareRoute = LocalePublicTeamsCompareRouteImport.update({
            id: '/teams/compare',path: '/teams/compare',getParentRoute: () => LocalePublicRouteRoute
          })
const LocaleRadarEventsEventIdRoute = LocaleRadarEventsEventIdRouteImport.update({
            id: '/events/$eventId',path: '/events/$eventId',getParentRoute: () => LocaleRadarRoute
          })
const LocaleRadarOpportunitiesOpportunityIdRoute = LocaleRadarOpportunitiesOpportunityIdRouteImport.update({
            id: '/opportunities/$opportunityId',path: '/opportunities/$opportunityId',getParentRoute: () => LocaleRadarRoute
          })
const LocaleResearchMatchesMatchIdRoute = LocaleResearchMatchesMatchIdRouteImport.update({
            id: '/matches/$matchId',path: '/matches/$matchId',getParentRoute: () => LocaleResearchRoute
          })
const LocaleResearchPlayersPlayerIdRoute = LocaleResearchPlayersPlayerIdRouteImport.update({
            id: '/players/$playerId',path: '/players/$playerId',getParentRoute: () => LocaleResearchRoute
          })
const PublicHistoryMatchesHistoricalMatchIdRoute = PublicHistoryMatchesHistoricalMatchIdRouteImport.update({
            id: '/history/matches/$historicalMatchId',path: '/history/matches/$historicalMatchId',getParentRoute: () => PublicRouteRoute
          })
const PublicTeamsTeamIdHistoryRoute = PublicTeamsTeamIdHistoryRouteImport.update({
            id: '/teams/$teamId_/history',path: '/teams/$teamId/history',getParentRoute: () => PublicRouteRoute
          })
const RadarEventsEventIdWhaleOrdersRoute = RadarEventsEventIdWhaleOrdersRouteImport.update({
            id: '/whale-orders',path: '/whale-orders',getParentRoute: () => RadarEventsEventIdRoute
          })
const LocalePublicHistoryMatchesHistoricalMatchIdRoute = LocalePublicHistoryMatchesHistoricalMatchIdRouteImport.update({
            id: '/history/matches/$historicalMatchId',path: '/history/matches/$historicalMatchId',getParentRoute: () => LocalePublicRouteRoute
          })
const LocalePublicTeamsTeamIdHistoryRoute = LocalePublicTeamsTeamIdHistoryRouteImport.update({
            id: '/teams/$teamId_/history',path: '/teams/$teamId/history',getParentRoute: () => LocalePublicRouteRoute
          })





const LocalePublicRouteRouteChildren = {
  LocalePublicMatchesRoute: LocalePublicMatchesRoute,LocalePublicTeamsPlayersRoute: LocalePublicTeamsPlayersRoute,LocalePublicIndexRoute: LocalePublicIndexRoute,LocalePublicLegalDocumentRoute: LocalePublicLegalDocumentRoute,LocalePublicPlayersPlayerIdRoute: LocalePublicPlayersPlayerIdRoute,LocalePublicTeamsTeamIdRoute: LocalePublicTeamsTeamIdRoute,LocalePublicTeamsCompareRoute: LocalePublicTeamsCompareRoute,LocalePublicHistoryMatchesHistoricalMatchIdRoute: LocalePublicHistoryMatchesHistoricalMatchIdRoute,LocalePublicTeamsTeamIdHistoryRoute: LocalePublicTeamsTeamIdHistoryRoute
}

const LocalePublicRouteRouteWithChildren = LocalePublicRouteRoute._addFileChildren(LocalePublicRouteRouteChildren)




const LocaleRadarRouteChildren = {
  LocaleRadarWorldcupRoute: LocaleRadarWorldcupRoute,LocaleRadarIndexRoute: LocaleRadarIndexRoute,LocaleRadarEventsEventIdRoute: LocaleRadarEventsEventIdRoute,LocaleRadarOpportunitiesOpportunityIdRoute: LocaleRadarOpportunitiesOpportunityIdRoute
}

const LocaleRadarRouteWithChildren = LocaleRadarRoute._addFileChildren(LocaleRadarRouteChildren)




const LocaleResearchRouteChildren = {
  LocaleResearchEvidenceRoute: LocaleResearchEvidenceRoute,LocaleResearchHeadToHeadRoute: LocaleResearchHeadToHeadRoute,LocaleResearchWorldcupRoute: LocaleResearchWorldcupRoute,LocaleResearchIndexRoute: LocaleResearchIndexRoute,LocaleResearchMatchesMatchIdRoute: LocaleResearchMatchesMatchIdRoute,LocaleResearchPlayersPlayerIdRoute: LocaleResearchPlayersPlayerIdRoute
}

const LocaleResearchRouteWithChildren = LocaleResearchRoute._addFileChildren(LocaleResearchRouteChildren)



const LocaleRouteRouteChildren = {
  LocalePublicRouteRoute: LocalePublicRouteRouteWithChildren,LocaleRadarRoute: LocaleRadarRouteWithChildren,LocaleResearchRoute: LocaleResearchRouteWithChildren,LocaleAuthPathnameRoute: LocaleAuthPathnameRoute,LocaleMatchesMatchIdRoute: LocaleMatchesMatchIdRoute
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(LocaleRouteRouteChildren)




const PublicRouteRouteChildren = {
  PublicMatchesRoute: PublicMatchesRoute,PublicTeamsPlayersRoute: PublicTeamsPlayersRoute,PublicIndexRoute: PublicIndexRoute,PublicLegalDocumentRoute: PublicLegalDocumentRoute,PublicPlayersPlayerIdRoute: PublicPlayersPlayerIdRoute,PublicTeamsTeamIdRoute: PublicTeamsTeamIdRoute,PublicTeamsCompareRoute: PublicTeamsCompareRoute,PublicHistoryMatchesHistoricalMatchIdRoute: PublicHistoryMatchesHistoricalMatchIdRoute,PublicTeamsTeamIdHistoryRoute: PublicTeamsTeamIdHistoryRoute
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(PublicRouteRouteChildren)




const AdminRouteChildren = {
  AdminDataQualityRoute: AdminDataQualityRoute,AdminMappingsRoute: AdminMappingsRoute,AdminMonitoringRoute: AdminMonitoringRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const RadarEventsEventIdRouteChildren = {
  RadarEventsEventIdWhaleOrdersRoute: RadarEventsEventIdWhaleOrdersRoute
}

const RadarEventsEventIdRouteWithChildren = RadarEventsEventIdRoute._addFileChildren(RadarEventsEventIdRouteChildren)



const RadarRouteChildren = {
  RadarWorldcupRoute: RadarWorldcupRoute,RadarIndexRoute: RadarIndexRoute,RadarEventsEventIdRoute: RadarEventsEventIdRouteWithChildren,RadarOpportunitiesOpportunityIdRoute: RadarOpportunitiesOpportunityIdRoute
}

const RadarRouteWithChildren = RadarRoute._addFileChildren(RadarRouteChildren)




const ResearchRouteChildren = {
  ResearchEvidenceRoute: ResearchEvidenceRoute,ResearchHeadToHeadRoute: ResearchHeadToHeadRoute,ResearchOpportunitiesRoute: ResearchOpportunitiesRoute,ResearchWorldcupRoute: ResearchWorldcupRoute,ResearchIndexRoute: ResearchIndexRoute,ResearchMatchesMatchIdRoute: ResearchMatchesMatchIdRoute,ResearchPlayersPlayerIdRoute: ResearchPlayersPlayerIdRoute,ResearchTeamsTeamRoute: ResearchTeamsTeamRoute
}

const ResearchRouteWithChildren = ResearchRoute._addFileChildren(ResearchRouteChildren)




const SettingsRouteChildren = {
  SettingsPathnameRoute: SettingsPathnameRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)

const rootRouteChildren = {
  LocaleRouteRoute: LocaleRouteRouteWithChildren,PublicRouteRoute: PublicRouteRouteWithChildren,AdminRoute: AdminRouteWithChildren,DashboardRoute: DashboardRoute,ForbiddenRoute: ForbiddenRoute,RadarRoute: RadarRouteWithChildren,ResearchRoute: ResearchRouteWithChildren,SettingsRoute: SettingsRouteWithChildren,AuthPathnameRoute: AuthPathnameRoute,MatchesMatchIdRoute: MatchesMatchIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)